import Vue from 'vue'
import VueToast from 'vue-toast-notification'
Vue.use(VueToast)

export const errorNotification = mess => {
  return Vue.$toast.open({
    message: mess || 'error',
    type: 'error',
    position: 'top'
  })
}
